export const ToStepperTitle = (x: string) => {
  switch (x) {
    case 'parcel':
      return 'Parcel Details';

    case 'address':
      return 'Address Details';

    case 'customs':
      return 'Customs';

    case 'confirm':
    case 'basket':
      return 'Order Summary';

    case 'payment':
      return 'Payment Options';

    case 'account':
      return 'Account';

    case 'parcels':
      return 'Parcels';

    case 'origin':
    case 'collection':
      return 'Collection';

    case 'delivery':
    case 'destination':
      return 'Delivery';

    case 'extras':
      return 'Extras';

    default:
      return x;
  }
};
